import { Arbeitszeit } from '../entities';
import { E2NTableCell } from '../../../components/Table';
import {
  RechtshinweiseTooltip,
  ZuschlaegeTooltip,
  TerminTooltip,
  BemerkungTooltip,
} from '../components/Tooltips';

interface ArbeitszeitTooltipsCellProps {
  arbeitszeit: Arbeitszeit;
}

const ArbeitszeitTooltipsCell = (props: ArbeitszeitTooltipsCellProps) => {
  const { arbeitszeit } = props;

  return (
    !arbeitszeit.abwesenheit && (
      <E2NTableCell className="font-semibold w-40" isBorderVisible>
        <div className="flex gap-2 justify-between">
          <RechtshinweiseTooltip
            rechtshinweise={{
              rechtshinweise: arbeitszeit.rechtshinweise,
            }}
          />
          <ZuschlaegeTooltip zuschlaege={arbeitszeit.zuschlaege ?? []} />
          <TerminTooltip termin={arbeitszeit.termin} />
          <BemerkungTooltip bemerkung={arbeitszeit.bemerkung} />
        </div>
      </E2NTableCell>
    )
  );
};

export default ArbeitszeitTooltipsCell;
